import React from "react";
import styled from "styled-components";
import { theme } from "../styles/theme";

import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import Container from "../styles/Container";

const OwnerSection = styled.section`
  background: var(--lightgrey);
  padding: 10rem 0;
  /* margin-bottom: 35rem;
  @media ${theme.devices.sm} {
    margin-bottom: 45rem;
  }
  @media ${theme.devices.md} {
    margin-bottom: 55rem;
  }
  @media ${theme.devices.lg} {
    margin-bottom: 0;
  } */
`;

const OwnersGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 4rem;
  @media ${theme.devices.lg} {
    grid-template-columns: 1fr 1fr;
  }
`;

const FromTheOwner = styled.h1`
  font-weight: 800;
  letter-spacing: 0.1rem;
  font-size: 6rem;
  background: conic-gradient(
    from 0.25turn at 10% 30%,
    var(--lightblue),
    10deg,
    var(--grey),
    350deg,
    var(--lightblue)
  );
  /* background: -webkit-linear-gradient(var(--blue), var(--black)); */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const OwnerBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const OwnerText = styled.p`
  font-size: clamp(1em, 1.5vw, 1.1em);
`;

const Owner = styled.div`
  display: flex;
  p {
    margin-left: 2rem;
  }
`;

const BizImages = styled.div``;

const TestImage = styled(GatsbyImage)`
  width: 50%;

  border-radius: 0.7rem;
  box-shadow: ${theme.shadow.image};
  &:nth-child(1) {
  }
  &:nth-child(2) {
  }
`;
const ProfilePic = styled.div``;
export default function OwnerInfo() {
  const data = useStaticQuery(graphql`
    query {
      zero: file(relativePath: { eq: "zero.jpg" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      one: file(relativePath: { eq: "one.jpg" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      two: file(relativePath: { eq: "two.jpg" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `);
  return (
    <OwnerSection>
      <Container>
        <OwnersGrid>
          <OwnerBox>
            <FromTheOwner>From the owner</FromTheOwner>
            <OwnerText>
              “We guarantee you the best car wash experience, exceptional
              service by our professional, attentive Customer Service Advisors,
              and hyper-clean facilities. Find your nearest location below for
              service offerings and pricing”
            </OwnerText>
            <Owner>
              <ProfilePic>
                <StaticImage src="../assets/images/owner.png" />
              </ProfilePic>
              <p>William Bond</p>
            </Owner>
          </OwnerBox>

          <BizImages>
            <TestImage
              image={getImage(data.two.childImageSharp.gatsbyImageData)}
            />
            <TestImage
              image={getImage(data.one.childImageSharp.gatsbyImageData)}
            />
            <TestImage
              image={getImage(data.zero.childImageSharp.gatsbyImageData)}
            />
          </BizImages>
        </OwnersGrid>
      </Container>
    </OwnerSection>
  );
}
